import useChunkErrorHook from "@/shared/hooks/useChunkErrorHook";
import useDarkModeHook from "@/shared/hooks/useDarkModeHook";
import useFullScreenDetect from "@/shared/hooks/useFullScreenDetect";
import useReloadWindowOnBranchIdChange from "@/shared/hooks/useGlobalWindowRefreshHook";
import useIsAuth from "@/shared/hooks/useIsAuth";
import useRTL from "@/shared/hooks/useRTL";
import useWindowReset from "@/shared/hooks/useWindowReset";
import LayoutConfirmation from "../Layout/LayoutConfirmation";
import Modals from "../Modals/Modals";
import PriorityModals from "../Modals/PriorityModals";
import AccessDeniedModal from "./AccessDeniedModal";
import AuthGlobal from "./AuthGlobal";
import Confirm from "./Confirm";
import DynamicGlobals from "./DynamicGlobals";

const Globals = () => {
  const isAuth = useIsAuth();
  useWindowReset();
  useFullScreenDetect();
  useDarkModeHook();
  useRTL();
  useReloadWindowOnBranchIdChange();
  useChunkErrorHook();
  return (
    <>
      {isAuth && <AuthGlobal />}
      {isAuth && <AccessDeniedModal />}
      <Confirm />
      {/* <Tooltip style={{ zIndex: 9999999 }} id="my-tooltip" place="bottom" /> */}
      <LayoutConfirmation />
      <PriorityModals />
      <Modals />
      <DynamicGlobals />
    </>
  );
};

export default Globals;
